import { render } from "./CustomerCreate.vue?vue&type=template&id=a8045080"
import script from "./CustomerCreate.vue?vue&type=script&lang=js"
export * from "./CustomerCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__